import { useMemo } from 'react';
import type { Jast } from '@atlaskit/jql-ast';
import type { TextSearchInputClauseType } from './types.tsx';
import { TextSearchInputClauseCollectingVisitor } from './text-search-input-clause-collecting-visitor.tsx';

export const useTextSearchInputClause = (
	ast: Jast,
	textSearchInputJqlTerm: string | undefined,
): TextSearchInputClauseType => {
	return useMemo(
		() => getTextSearchInputClause(ast, textSearchInputJqlTerm),
		[ast, textSearchInputJqlTerm],
	);
};

export const getTextSearchInputClause = (
	ast: Jast,
	textSearchInputJqlTerm: string | undefined,
): TextSearchInputClauseType => {
	if (!textSearchInputJqlTerm) return;
	const visitor = new TextSearchInputClauseCollectingVisitor(textSearchInputJqlTerm);
	return ast.query ? visitor.visit(ast.query) : undefined;
};
